import { Head } from "zudoku/components";

"use client";

export default function SwaggerM2mPage() {
    return (
        <section style={{ padding: "1rem 0" }}>
            <Head>
                <title>Swagger</title>
            </Head>
            <iframe
                src="/swagger/swagger-m2m.html"
                style={{
                    width: "100%",
                    height: "100vh",
                    border: "none"
                }}
            />
        </section>
    );
}
